module.exports = __webpack_public_path__ + "img/IMG_9674-6.d4e5ef63.png";